import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import {
  Pagination,
  Message,
  Loading,
  Carousel,
  CarouselItem,
  // Button,
  Input,
  Select,
  Option,
  OptionGroup,
  Dialog,
} from "element-ui";

import "./styles/base.scss";
import "./styles/common.scss";
// import PageHeader from "@/components/PageHeader.vue";
import PageFooter from "@/components/PageFooter.vue";
import FixedLeft from "@/components/FixedLeft.vue";
import FixedRight from "@/components/FixedRight.vue";
import IndexHeader from "@/components/IndexHeader.vue";
import Teleport from "@/components/Teleport.vue";
import MetaInfo from 'vue-meta-info'
import 'babel-polyfill'
import 'url-search-params-polyfill'
Vue.config.productionTip = false;
const scrollToTop = () => {
  // const c = document.documentElement.scrollTop || document.body.scrollTop;
  // if (c > 0) {
  //   window.requestAnimationFrame(scrollToTop);
  //   window.scrollTo(0, c - c / 8);
  // }
}

Vue.prototype.scrollToTop = scrollToTop
Vue.prototype.$setCssVar = (key, value) => {
  const doc = document.documentElement
  // doc.style.setProperty('--doc-height', `${window.innerHeight}px`)
  doc.style.setProperty && doc.style.setProperty(key, value)
}

Vue.use(Dialog)
Vue.use(Select)
Vue.use(OptionGroup)
Vue.use(Option)
Vue.use(Pagination)
Vue.use(Carousel)
Vue.use(CarouselItem)
Vue.use(Input)
Vue.use(Loading.directive);
// 
Vue.prototype.$message = Message;
Vue.prototype.$loading = Loading.service;


Vue.filter('baseImg', (v) => {
  if (!v) return ''
  if (v.startsWith('http')) {
    return v
  }
  return `${process.env.VUE_APP_BASE_API_IMAGE || ''}${v}`
})
// Vue.filter('dayjs', (v) => {
//   const time = v * 1000
//   if (String(time).length === 13) {
//     const date = new Date(time)
//     return date.toLocaleDateString().replace(/\//g, '-')
//   }
//   return v
// })
Vue.filter('dayjs', (v, type) => {
  const time = v * 1000
  if (String(time).length === 13) {
    const date = new Date(time)
    const YYYY = date.getFullYear()
    const m = date.getMonth() + 1
    const d = date.getDate()
    const mm = String(m).padStart(2, 0)
    const dd = String(d).padStart(2, 0)
    if (type === 'date') {
      return `${mm}-${dd}`
    } else if (type === 'year-date') {
      return `${YYYY}-${mm}-${dd}`
    }
    return date.toLocaleDateString().replace(/\//g, '-')
  }
  return v
})
// Vue.component("PageHeader", PageHeader);
Vue.component("PageFooter", PageFooter);
Vue.component("FixedLeft", FixedLeft);
Vue.component("FixedRight", FixedRight);
Vue.component("IndexHeader", IndexHeader);
Vue.component("Teleport", Teleport);
Vue.use(MetaInfo)

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");